import { Misc } from "@/data/util/Misc";

import { trans } from "@/app/localization/Trans";

enum DateTimeWeekday {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}

export class DateTimeUtils {
    static toDateTimeWithDayOfWeekAndCirca(date: Date, includeCirca: boolean = true): string {
        const dayOfWeek = trans.general.shortWeekDay[DateTimeWeekday[date.getDay()]];
        const day = Misc.padDigits(date.getDate(), 2);
        const month = Misc.padDigits(date.getMonth() + 1, 2);
        const year = date.getFullYear();
        const hours = Misc.padDigits(date.getHours(), 2);
        const minutes = Misc.padDigits(date.getMinutes(), 2);

        if (includeCirca) {
            return `${dayOfWeek}, ${day}.${month}.${year} ca. ${hours}:${minutes}`;
        } else {
            return `${dayOfWeek}, ${day}.${month}.${year} ${hours}:${minutes}`;  
        }
    }
}
